"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/DOFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_63)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_63`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 15.1017H8.8421V23.9509H-6V15.1017Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H8.8421V8.85614H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0878 0H29.9299V8.85614H15.0878V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0878 15.1017H29.9299V23.9509H15.0878V15.1017Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 9.1228H8.46313V12.5895C8.46313 12.5895 9.83156 13.0105 11.9649 13.0105V9.1228Z",
					fill: "#0052B4",
					stroke: "white",
					strokeWidth: .350877,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.46313 12.5895V13.0105C8.46313 14.9404 10.028 16.5123 11.9649 16.5123V13.0105C9.83156 13.0105 8.46313 12.5895 8.46313 12.5895Z",
					fill: "#D80027",
					stroke: "white",
					strokeWidth: .350877,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.965 16.5123C13.8948 16.5123 15.4667 14.9474 15.4667 13.0105V12.5895C15.4667 12.5895 14.0983 13.0105 11.965 13.0105V16.5123Z",
					fill: "#0052B4",
					stroke: "white",
					strokeWidth: .350877,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.965 9.1228V13.0105C14.0983 13.0105 15.4667 12.5895 15.4667 12.5895V9.1228H11.965Z",
					fill: "#D80027",
					stroke: "white",
					strokeWidth: .350877,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_63`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as DOFlag };
